import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { OutletService } from './outlet.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-outlet',
  templateUrl: './outlet.component.html',
  styleUrls: ['./outlet.component.scss']
})
export class OutletComponent implements OnInit {

  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'outlet_name', 'outlet_code', 'outlet_for_code', 'outlet_map_code', 'contact_person', 'trade_name', 'date_of_inauguration', 'status', 'action'];
  verificationDisplayedColumns: string[] = [
    'SNo',
    'username',
    'ip_address',
    'createdAt'
  ];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  verificationDataSource = new MatTableDataSource(this.ELEMENT_DATA);
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  outletForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");
  public statusFilter = new FormControl("All");
  public outletsList: any[] = [];
  dealershipTypeList: any = [{ name: "Branch", id: 1 }, { name: "Dealer", id: 2 }, { name: "Satellite", id: 3 }, { name: "ASSC", id: 4 }, { name: "Best Value", id: 5 }];
  constructor(private router: Router, private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private outletService: OutletService) {
    this.outletForm = this.fb.group({
      outletName: ['', Validators.required],
      outletCode: ['', [Validators.required, Validators.minLength(6)]],
      parentDealer: ['', Validators.required],
      // companyName: ['', Validators.required],
      tradeName: [''],
      dataOfInauguration: [''],
      dealershipType: ['', Validators.required],
      productCategory: ['', Validators.required],
      contactPersonName: [''],
      contactPersonNumber: [''],
      contactPersonEmail: ['', [Validators.required, Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      contactPersonNumberAlt: [''],
      emailIdCeo: [''],
      emailIdSales: [''],
      emailIdNonSales: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      emailIdService: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      emailIdSpares: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      alternateEmailId: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_insurance_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_finance_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_bestvalue_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_accessories_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_service_info_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      p_s_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      shopAddress: [''],
      status: ['', Validators.required],
      outLetForCode: ['', Validators.required],
      outLetMapCode: ['', Validators.required],
      district:[''],
      area:[''],
      locationCode:[''],
      cityName:['', Validators.required],
      city_cd:['', Validators.required],
      working_hour_from:['09:30:00'],
      working_hour_to:['19:30:00'],
      is_verified: [false]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public isOutletVerification: boolean = false;
  dropdownSettingsDealer = {};
  dropdownSettingsProCategory = {};
  ngOnInit() {
    this.getList();
    this.getDealerList();
    this.getProductCategoryList();
    this.dropdownSettingsDealer = {
      singleSelection: true,
      enableCheckAll: false,
      idField: 'id',
      textField: 'displayText',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };

    this.dropdownSettingsProCategory = {
      singleSelection: false,
      enableCheckAll: false,
      idField: 'id',
      textField: 'product_category',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
    this.statusFilter.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.outletForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    let emailIdCeo: any = ''
    let emailIdSpares: any = ''
    let emailIdSales: any = ''
    let emailIdService: any = ''
    let emailIdAlternateEmail: any = ''
    let emailPS: any = ''
    let parentDealer: any = ''
    parentDealer = this.parentDealerList.filter((item: any) => item.id == object.parent_dealer_id)
    object.outlet_emails.forEach((element: any) => {
      if (element.email_name == 'ceo') {
        emailIdCeo = element.email
      } else if (element.email_name == 'spares') {
        emailIdSpares = element.email
      } else if (element.email_name == 'sales_person') {
        emailIdSales = element.email
      } else if (element.email_name == 'service') {
        emailIdService = element.email
      } else if (element.email_name == 'alternate_email') {
        emailIdAlternateEmail = element.email
      } else if (element.email_name == 'p_and_s') {
        emailPS = element.email
      }
    });
    if (parentDealer.length > 0) {
      let id = parentDealer[0].region.id
      this.getDistrictList(id)
    }
    if (object.district_id) {
      this.getAreaList(object.district_id)
    }
    this.outletForm.patchValue({
      outletName: object.outlet_name,
      outletCode: object.outlet_code,
      locationCode: object.location_code,
      cityName: object.city_desc,
      city_cd: object.city_cd,
      parentDealer: parentDealer,
      tradeName: object.trade_name,
      dataOfInauguration: object.date_of_inauguration,
      dealershipType: object.dealership_type,
      productCategory: object.product_categories,
      contactPersonName: object.contact_person,
      contactPersonNumber: object.contact_person_number,
      contactPersonNumberAlt: object.contact_person_alt_number,
      contactPersonEmail: object.contact_person_email,
      emailIdCeo: emailIdCeo,
      emailIdSales: emailIdSales,
      emailIdSpares: emailIdSpares,
      emailIdService: emailIdService,
      alternateEmailId: emailIdAlternateEmail,
      p_s_email: emailPS,
      emailIdNonSales: object.non_sales_email,
      shopAddress: object.showroom_address,
      status: object.status ? 1 : 0,
      outLetForCode: object.outlet_for_code,
      outLetMapCode: object.outlet_map_code,
      district: object.district_id,
      area: object.area_id,
      non_sales_insurance_email: object.non_sales_insurance_email,
      non_sales_finance_email: object.non_sales_finance_email,
      non_sales_bestvalue_email: object.non_sales_bestvalue_email,
      non_sales_accessories_email: object.non_sales_accessories_email,
      non_sales_service_info_email: object.non_sales_service_info_email,
      is_verified: object.is_verified_by_user,
      working_hour_from: object.working_hour_from,
      working_hour_to: object.working_hour_to
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.isOutletVerification = false;
    this.getList();
  }

  applyFilter() {
    let filteredData = this.outletsList || [];

    // Filter by dropdown status selection
    const statusVal = this.statusFilter.value;
    if (statusVal == '1') {
      filteredData = filteredData.filter((data: any) => data.alert_flag == 1);
    } else if (statusVal == '2') {
      filteredData = filteredData.filter((data: any) => data.alert_flag == 2);
    }

    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
    if (filterValue) {
      filteredData = filteredData.filter((data: any) => {
        const outlet = data.outlet_name ? data.outlet_name.toLowerCase().includes(filterValue) : false;
        const outletCodeMatch = data.outlet_code ? data.outlet_code.toLowerCase().includes(filterValue) : false;
        const outletMapCodeMatch = data.outlet_map_code ? data.outlet_map_code.toLowerCase().includes(filterValue) : false;
        return outlet || outletCodeMatch || outletMapCodeMatch;
      });
    }

    this.dataSource.data = filteredData;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.outletForm.valid) {
      const outletData = this.outletForm.value;
      let prod: any = outletData.productCategory.map((item: any) => item.id)
      let parentDealerId: any = ''
      if (outletData.parentDealer.length > 0) {
        parentDealerId = outletData.parentDealer[0].id
      }
      let obj = {
        "parent_dealer_id": parentDealerId,
        "outlet_name": outletData.outletName,
        "outlet_code": outletData.outletCode,
        "location_code": outletData.locationCode,
        "city_desc": outletData.cityName,
        "city_cd": outletData.city_cd,
        "working_hour_from": outletData.working_hour_from,
        "working_hour_to": outletData.working_hour_to,
        "trade_name": outletData.tradeName,
        "date_of_inauguration": outletData.dataOfInauguration ? moment(outletData.dataOfInauguration).format('YYYY-MM-DD') : null,
        "dealership_type": outletData.dealershipType,
        "contact_person": outletData.contactPersonName,
        "contact_person_email": outletData.contactPersonEmail,
        "non_sales_email": outletData.emailIdNonSales,
        "contact_person_number": outletData.contactPersonNumber,
        "contact_person_alt_number": outletData.contactPersonNumberAlt,
        "showroom_address": outletData.shopAddress,
        "status": parseInt(outletData.status),
        "product_category": prod,
        "outlet_for_code": outletData.outLetForCode,
        "outlet_map_code": outletData.outLetMapCode,
        non_sales_insurance_email: outletData.non_sales_insurance_email,
        non_sales_finance_email: outletData.non_sales_finance_email,
        non_sales_bestvalue_email: outletData.non_sales_bestvalue_email,
        non_sales_accessories_email: outletData.non_sales_accessories_email,
        non_sales_service_info_email: outletData.non_sales_service_info_email,
        non_sales_p_and_s_email: outletData.p_s_email,
        district_id: outletData.district ? outletData.district : null,
        area_id: outletData.area ? outletData.area : null,
        "emails": [
          { "ceo": outletData.emailIdCeo || '' },
          { "sales_person": outletData.emailIdSales || '' },
          { "spares": outletData.emailIdSpares || '' },
          { "service": outletData.emailIdService || '' },
          { "alternate_email": outletData.alternateEmailId || '' },
          { "p_and_s": outletData.p_s_email || '' }
        ]
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.outletService.createOutlet(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Outlet created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.outletForm.valid) {
      const outletData = this.outletForm.value;
      console.log("outletData: ", outletData)
      let prod: any = outletData.productCategory.map((item: any) => item.id)
      let parentDealerId: any = ''
      if (outletData.parentDealer.length > 0) {
        parentDealerId = outletData.parentDealer[0].id
      }
      let obj = {
        "parent_dealer_id": parentDealerId,
        "outlet_name": outletData.outletName,
        "outlet_code": outletData.outletCode,
        "location_code": outletData.locationCode,
        "city_desc": outletData.cityName,
        "city_cd": outletData.city_cd,
        "trade_name": outletData.tradeName,
        "date_of_inauguration": outletData.dataOfInauguration ? moment(outletData.dataOfInauguration).format('YYYY-MM-DD') : null,
        "dealership_type": outletData.dealershipType,
        "contact_person": outletData.contactPersonName,
        "contact_person_email": outletData.contactPersonEmail,
        "non_sales_email": outletData.emailIdNonSales,
        "contact_person_number": outletData.contactPersonNumber,
        "contact_person_alt_number": outletData.contactPersonNumberAlt,
        "showroom_address": outletData.shopAddress,
        "status": parseInt(outletData.status),
        "product_category": prod,
        "outlet_for_code": outletData.outLetForCode,
        "outlet_map_code": outletData.outLetMapCode,
        "working_hour_from": outletData.working_hour_from,
        "working_hour_to": outletData.working_hour_to,
        non_sales_insurance_email: outletData.non_sales_insurance_email,
        non_sales_finance_email: outletData.non_sales_finance_email,
        non_sales_bestvalue_email: outletData.non_sales_bestvalue_email,
        non_sales_accessories_email: outletData.non_sales_accessories_email,
        non_sales_service_info_email: outletData.non_sales_service_info_email,
        non_sales_p_and_s_email: outletData.p_s_email,
        district_id: outletData.district ? outletData.district : null,
        area_id: outletData.area ? outletData.area : null,
        is_verified: outletData.is_verified,
        "emails": [
          { "ceo": outletData.emailIdCeo || '' },
          { "sales_person": outletData.emailIdSales || '' },
          { "spares": outletData.emailIdSpares || '' },
          { "service": outletData.emailIdService || '' },
          { "alternate_email": outletData.alternateEmailId || '' },
          { "p_and_s": outletData.p_s_email || '' }
        ]
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.outletService.updateOutlet(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Outlet updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.outletForm.patchValue({
      outletName: '',
      outletCode: '',
      parentDealer: '',
      tradeName: '',
      dataOfInauguration: '',
      dealershipType: '',
      productCategory: '',
      contactPersonName: '',
      contactPersonNumber: '',
      contactPersonEmail: '',
      contactPersonNumberAlt: '',
      emailIdCeo: '',
      emailIdSales: '',
      emailIdService: '',
      emailIdSpares: '',
      emailIdNonSales: '',
      alternateEmailId: '',
      shopAddress: '',
      status: '',
      outLetForCode: '',
      outLetMapCode: '',
      non_sales_insurance_email: '',
      non_sales_finance_email: '',
      non_sales_bestvalue_email: '',
      non_sales_accessories_email: '',
      non_sales_service_info_email: '',
      district: '',
      area: '',
      p_s_email: '',
      is_verified: '',
      city_cd: '',
      cityName: '',
      working_hour_from: '09:30:00',
      working_hour_to: '19:30:00'
    });
  }

  allowNumbersOnly(event: any) {
    this.sharedService.allowNumbersOnly(event);
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.outletService.getOutlet().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data;
        this.outletsList = responseData.data;
        this.dataSource = new MatTableDataSource(this.outletsList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.applyFilter();
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  countryList: any = []
  getCountryList() {
    this.outletService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.countryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  stateList: any = []
  getStateList() {
    this.outletService.getState().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.stateList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  zoneList: any = []
  getZoneList() {
    this.outletService.getZone().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.zoneList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  regionList: any = []
  getRegionList() {
    this.outletService.getZone().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.regionList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  // districtList: any = []
  // getDistrictList() {
  //   this.outletService.getZone().subscribe((response: any) => {
  //     let responseData = response.body
  //     if (responseData.responseCode == 200) {
  //       this.districtList = responseData.data
  //     }
  //   }, (err: any) => {
  //     this.isLoading = new BehaviorSubject<boolean>(false);
  //   });
  // }

  // areaList: any = []
  // getAreaList() {
  //   this.outletService.getZone().subscribe((response: any) => {
  //     let responseData = response.body
  //     if (responseData.responseCode == 200) {
  //       this.areaList = responseData.data
  //     }
  //   }, (err: any) => {
  //     this.isLoading = new BehaviorSubject<boolean>(false);
  //   });
  // }

  parentDealerList: any = []
  getDealerList() {
    this.outletService.getDealerList().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.parentDealerList = responseData.data
        this.parentDealerList = this.parentDealerList.map((dealer: any) => ({
          ...dealer,
          displayText: `${dealer.dealer_name} (${dealer.dealer_code})` // Modify as per your requirement
        }));
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  productCategoryList: any = []
  getProductCategoryList() {
    let reqObject = {
      flag: 'list'
    }
    this.outletService.productCategoryList(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.productCategoryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  onDealerSelect(item: any) {
    console.log("item: ", item)
    let dealer: any = [...this.parentDealerList.filter((dealer: any) => dealer.id == item.id)]
    console.log(dealer)
    if (dealer.length > 0) {
      this.getDistrictList(dealer[0].region.id)
    }
  }

  onDealerDeSelect(item: any) {
    this.districtList = [];
    this.areaList = [];
  }


  districtList: any = []
  getDistrictList(regionId?: any) {
    this.districtList = []
    this.areaList = [];
    this.outletForm.patchValue({ district: '', area: '' })
    let id: any = this.outletForm.value.region ? this.outletForm.value.region : regionId;
    this.outletService.getDistrictByRegion(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.districtList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  areaList: any = []
  getAreaList(districtId?: any) {
    this.areaList = []
    this.outletForm.patchValue({ area: '' })
    let id: any = this.outletForm.value.district ? this.outletForm.value.district : districtId;
    this.outletService.getAreaByDistrict(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.areaList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  goToImport() {
    this.router.navigateByUrl('/suzuki/import', { state: { page: { name: 'outlet' } } });
  }

  export() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.outletService.getExport().subscribe({
      next: (res: any) => {
        if (res.body.responseCode == 200) {
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.success(res.body.responseMessage);
        } else {
          this.toastr.error(res.body.responseMessage);
        }
      }, error: (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      },
      complete: () => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    });
  }

  viewUserData(outletData?: any) {
    this.isLoading.next(true);

    //this.isOutletVerification = true;
    this.outletService.getUserList(outletData?.id, 'Outlet').subscribe({
      next: (response: any) => {
        const responseData = response.body;
        console.log("responseData", responseData);
        if (responseData.responseCode === 200) {
          this.isLoading.next(false);

          const verificationRows: any[] = [];

          responseData.data.forEach((outlet: any) => {
            outlet.outletVerifications?.forEach((verification: any) => {
              verificationRows.push({
                username: verification.user?.username,
                createdAt: verification.createdAt,
                outlet_for_code: outlet.outlet_for_code,
                ip_address: verification.ip_address
              });
            });
          });

          this.ELEMENT_DATA = verificationRows;
          this.verificationDataSource = this.ELEMENT_DATA;
          console.log("this.ELEMENT_DATA", this.ELEMENT_DATA);

          this.verificationDataSource.sort = this.sort;
          // this.verificationDataSource.paginator = this.verificationPaginator;

          // Show verification view
          this.isCreate = false;
          this.isEdit = false;
          this.isOutletVerification = true;
        } else {
          this.isLoading.next(false);
        }
      },
      error: () => {
        this.isLoading.next(false);
      }
    });
  }
}
